import { Component, Inject, Mixins } from '@/vue-property-decorator'
import { _GameNameVerticalBase as GameNameVerticalBase } from './cssVar/gameNameVerticalBase'
import { _GameNameVerticalDefault as GameNameVerticalDefault } from './cssVar/gameNameVerticalDefault'
import { _GameNameVerticalLarger as GameNameVerticalLarger } from './cssVar/gameNameVerticalLarger'
import { _GameNameVerticalSmall as GameNameVerticalSmall } from './cssVar/gameNameVerticalSmall'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { VerticalProps } from '../../components/basePropsConfig'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type GameNameVerticalCssVarManager =
  GetCssVarManager<GameNameVerticalBase>
export { GameNameVerticalBase }
/** 游戏名称上下结构 */
@Component<GameNameVertical>({
  name: 'GameNameVertical'
})
export default class GameNameVertical extends Mixins<
  BaseCssVarInject<GameNameVerticalBase>
>(BaseCssVarInject) {
  /** 默认尺寸 */
  public static getCssVarDefault = () => new GameNameVerticalDefault()
  /** 小号尺寸 */
  public static getCssVarSmall = () => new GameNameVerticalSmall()
  /** 大号尺寸 */
  public static getCssVarLarger = () => new GameNameVerticalLarger()

  @Inject() cardProps!: Required<VerticalProps>

  /** 渲染游戏名称 */
  render() {
    const { gameName, secondaryName } = this.cardProps
    return (
      <div
        class={{
          [style['game-name-vertical']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <p class={[style['top-name'], 'top-name']}>{gameName}</p>
        <p class={[style['bottom-name'], 'bottom-name']}>{secondaryName}</p>
      </div>
    )
  }
}
